import moment from 'moment';
import React, { useState } from 'react';
import styled from 'styled-components';

import Select from '@components/Select';
import useAPI from '@hooks/useAPI';
import Spinner from '@shared/Spinner';

import ScreenCharts from './ScreenCharts';

const Container = styled.div`
  width: 100%;
`;
const InputGroup = styled.div`
  display: flex;
  justify-content: center;

  input {
    min-width: 160px;
    font-family: ${props => props.theme.font.primary};
    padding: 5px;
    margin: 0px 0px 0px 10px;
    border: ${props => props.theme.borderMd};
    border-color: #d2d6d9;
    border-radius: ${props => props.theme.inputBorderRadius};
  }
`;

/*
const CHART_OPTIONS = [
  ['ALERTS', 'Alerts'],
  ['SCREENED_ALERTS', 'Screened Alerts'],
  ['ALERT_RATE', 'Alert Rate'],
];
*/

export default function SystemPerformance() {
  const today = moment();
  const earlierDay = moment().subtract(30, 'days');
  const initialStartDate = earlierDay.format('YYYY-MM-DD');
  const initialEndDate = today.format('YYYY-MM-DD');
  const [startDate, setStartDate] = useState(initialStartDate);
  const [endDate, setEndDate] = useState(initialEndDate);
  const [selectedChart, setSelectedChart] = useState("traffic");
  const customer_id = process.env.REACT_APP_CUSTOMER_ID

  const metricsOptionFetcher = useAPI(
    'get',
    'ScreenConsoleApi',
    `config/metrics/${customer_id}`,
    '',
    false,
    '',
    false
  );


  let { response, isLoading } = metricsOptionFetcher;

  let options = [];
  let metricsSelection = {};

  if (isLoading || response == null) {
    return <Spinner />;
  }
  else{
    console.log("no longer loading");
    console.log(response);  
    metricsSelection = response;
    options = Object.keys(response).map((item) => {return [item, item]});
  }
  
  console.log("options!!!!!");
  console.log(options);

  const onChangeStart = e => {
    setStartDate(e.target.value);
  };
  const onChangeEnd = e => {
    setEndDate(e.target.value);
  };

  return (
    <Container>
      <InputGroup>
        <Select
          options={options}
          value={selectedChart}
          onChange={e => setSelectedChart(e.target.value)}
        />
        <input
          type='date'
          name='range-start'
          value={startDate}
          min='2018-01-01'
          max={endDate}
          onChange={onChangeStart}
        />
        <input
          type='date'
          name='range-end'
          value={endDate}
          min={startDate}
          max={initialEndDate}
          onChange={onChangeEnd}
        />
      </InputGroup>
      <ScreenCharts
        selected={selectedChart}
        metricsAvailable={metricsSelection}
        startDate={startDate}
        endDate={endDate}
      />
    </Container>
  );
}
